import { Button, Flex } from 'antd';
import { FC, PropsWithChildren } from 'react';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './OpenCloseAllBlocksButtons.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'open-close-all-blocks-buttons'
);
addTranslations(translations);

export interface OpenCloseAllBlocksButtonsProps extends PropsWithChildren {
  onClickOpen: () => void;
  onClickClose: () => void;
}

export const OpenCloseAllBlocksButtons: FC<OpenCloseAllBlocksButtonsProps> = (
  props
) => {
  const { onClickOpen, onClickClose } = props;
  const { t } = useTranslation();
  return (
    <Flex gap="small">
      <Button id="open-all-blocks" onClick={onClickOpen}>
        {t('open-all')}
      </Button>
      <Button id="close-all-blocks" onClick={onClickClose}>
        {t('close-all')}
      </Button>
    </Flex>
  );
};
